export default __webpack_public_path__ + "static/media/projectImg2.6a378d0e.jpg";